import contentfulGql from 'js/lib/contentfulGql';

import { entWebsitePartnerListFragment } from 'bundles/ent-website/queries/EntWebsitePartnerList';
import { ctaFragment, imageFragment, videoFragment } from 'bundles/ent-website/queries/common';

export const enterpriseArticleLinkFragment = contentfulGql`#graphql
  ${imageFragment}
  ${videoFragment}
  ${ctaFragment}
  ${entWebsitePartnerListFragment}
  fragment EnterpriseArticleLink on EnterpriseArticleBodyLinks {
    assets {
      block {
        title
        description
        url(transform: {
          width: 1500,
          quality: 60
        })
        width
        height
        sys {
          id
        }
      }
    },
    entries {
      block {
        __typename
        sys {
          id
        }

        ... on EnterpriseArticlesHighlight {
          body {
            json
          }
        }

        ... on EntWebsiteVideo {
          title
          previewImage {
            ...Image
          }
          iFrameEmbed
          video {
            ...Video
          }
        }

        ... on EnterpriseArticlesNativeAd {
          headline
          promoBody: body
          image {
            ...Image
          }
          cta {
            ...Cta
          }
          alignment
        }

        ... on EnterpriseArticlesInlinePromoUnit {
          headline
          promoBody: body
          backgroundColor
          fontColor
          logo {
            ...Image
          }
          image {
            ...Image
          }
          hideImageOnMobile
          cta {
            ...Cta
          }
          alignment
        }

        ... on EnterpriseArticlesPromoUnit {
          headline
          promoBody: body
          leftBackgroundColor
          rightBackgroundColor
          leftFontColor
          rightFontColor
          logo {
            ...Image
          }
          cta {
            ...Cta
          }
          coverImage {
            ...Image
          }
          rightContentType
          image {
            ...Image
          }
          partnerList {
            ...EntWebsitePartnerList
          }
          bulletPointsCollection {
            items {
              title
            }
          }
        }
      }
    }
  }
`;

export const enterpriseArticleFragment = contentfulGql`#graphql
  ${enterpriseArticleLinkFragment}
  fragment EnterpriseArticle on EnterpriseArticle {
    slug
    sys {
      firstPublishedAt
      publishedAt
    }
    title
    intro
    featuredImage {
      title
      description
      width
      height
      url(transform: {
        width: 1500,
        height: 680,
        resizeStrategy: FILL,
        resizeFocus: FACES,
        format: JPG_PROGRESSIVE,
        quality: 60
      })
    }
    featuredImageLink
  body {
      json
      links {
        ...EnterpriseArticleLink
      }
    }
    relatedArticlesCollection {
      items {
        title
        slug
        localizedCountryCode
        localizedLanguageCode
          sys {
            publishedAt
          }
      }
    }
    sources {
      json
    }
    category
    tags
    metaTitle
    metaDescription

  }
`;

export const enterpriseArticleQuery = contentfulGql`#graphql
  ${enterpriseArticleFragment}
  query EnterpriseArticle($slug: String!, $preview: Boolean!, $locale: String!) {
    enterpriseArticleCollection(where: {slug: $slug}, preview: $preview, locale: $locale, limit: 1) {
      items {
        ...EnterpriseArticle
      }
    }
  }
`;
